import React from "react";
import ReactDOM from "react-dom/client";
import "../src/style/index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import { injectStore } from './services/API';
injectStore(store);
import 'react-loading-skeleton/dist/skeleton.css'
import { Provider } from "react-redux";
import { setClearHomepageVideos } from './redux/ApiSlice/HomePageVideoSlice';

// Detect page refresh using Performance API
const detectPageRefresh = () => {
    const perfEntries = performance.getEntriesByType('navigation');
    if (perfEntries.length > 0) {
        return perfEntries[0].type === 'reload';
    }
    // Fallback for older browsers
    return performance.navigation && performance.navigation.type === 1;
};

// Clear homepage videos on page refresh
const isPageRefresh = detectPageRefresh();
const lastRefreshCheck = sessionStorage.getItem('lastRefreshCheck');
const now = Date.now();

if (isPageRefresh && (!lastRefreshCheck || now - parseInt(lastRefreshCheck) > 1000)) {
    sessionStorage.setItem('lastRefreshCheck', now.toString());
    store.dispatch(setClearHomepageVideos());
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App />
        </PersistGate>
    </Provider>,
);


reportWebVitals();

